<template>
  <div class="product_carousel">
    <vue-flux
      :options="fluxOptions"
      :images="fluxImages"
      :transitions="fluxTransitions"
      ref="slider"
    >
    </vue-flux>
    <img
      class="original"
      src="../../assets/images/icons/newhome/carousel/original.png"
    />
  </div>
</template>

<script>
import { VueFlux, Transitions } from "vue-flux";

export default {
  components: {
    VueFlux,
  },
  props: {
    visible: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      fluxOptions: {
        autoplay: false,
        delay: 1100,
      },
      fluxImages: [
        require("../../assets/images/icons/newhome/carousel/product1.png"),
        require("../../assets/images/icons/newhome/carousel/product2.png"),
        require("../../assets/images/icons/newhome/carousel/product3.png"),
      ],
      fluxTransitions: {
        transitionBook: Transitions.transitionSwipe,
      },
    };
  },
  watch: {
    visible(val) {
      // if (val) {
      //   this.$nextTick(() => {
      //     // console.log("this.$refs.slider", this.$refs.slider);
      //     // console.log("this.$refs.slider", this.$refs.slider.index);
      //     this.$refs.slider.play(1);
      //   });
      // } else {
      //   this.$nextTick(() => {
      //     this.$refs.slider.showImage(0);
      //     this.$refs.slider.stop();
      //   });
      // }
    },
  },
  mounted() {
    this.$refs.slider.play(1);
  },
};
</script>

<style scoped lang="less">
.product_carousel {
  width: 705px;
  height: 476px;
  overflow: hidden;
  border-radius: 16px;
  position: relative;
  /deep/ .mask {
    height: 476px !important;
    > div {
      // background-size: 705px 476px !important;
    }
  }
  /deep/ .spinner {
    display: none;
  }
  .original {
    position: absolute;
    top: 133px;
    left: 286px;
    z-index: 100;
    width: 133px;
    height: 262px;
  }
}

/* 小于等于1440px时应用的样式 */
@media (max-width: 1440px) {
  .product_carousel {
    width: 529px;
    height: 375px;
    /deep/ .mask {
      height: 375px !important;
      > div {
        // background-size: 529px 375px !important;
      }
    }
    .original {
      top: 115px;
      left: 215px;
      width: 100px;
      height: 197px;
    }
  }
}
</style>
